import React from "react";
import {
  Box,
  Grid,
  Typography
} from "@mui/material";
import {
  makeStyles
} from "@mui/styles";
import {useSelector} from "react-redux";

const HeadElement = ({roles}) => {
  const classes = useStyles();
  const user = useSelector(state => state.global.user);
  const [fullName] = React.useState(() => {
    return [user?.lastName, user?.firstName].filter((t) => !!t).join(' ')
  });

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item>
        <Typography className={classes.userName}>{fullName}</Typography>
      </Grid>
      <Grid item>
        <Box className={classes.role}>{(roles || []).find((t) => t.type === user?.role)?.name || user?.role}</Box>
      </Grid>
    </Grid>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {},
  role: {
    padding: "6px 24px",
    borderRadius: "10px",
    boxSizing: "border-box",
    background: "#FF3C4333",

    fontSize: 14,
    color: "#FF3C43",
    lineHeight: "16px",
    letterSpacing: "0.03em",

    "@media (max-width: 859px)": {
      padding: "6px 12px",
      borderRadius: "6px",
    }
  },
  userName: {
    fontSize: 24,
    color: "#434146",
    fontWeight: "600",
    lineHeight: "30px",
    letterSpacing: "0.03em",

    "@media (max-width: 859px)": {
      fontSize: 18,
      lineHeight: "20px"
    }
  },
}));

export default HeadElement
